// @ts-nocheck
// oxlint-disable no-unused-vars
import type {
	ApiResponseOfIReadOnlyListOfProjectDto,
	ApiResponseOfProjectDataDto,
	ApiResponseOfProjectDto,
	CreateProjectRequest,
	SaveProjectDataRequest,
	UpdateProjectRequest,
	UpdateProjectSharingRequest,
} from "../types";
import { apiFetch, type ApiResponse } from "@/api/fetch";

/** Auto-generated file. Do not edit. */

/**
 * DELETE `/projects/${id}`
 */
export const deleteApiProjectsById = ({
	id,
}: {
	/** @format uuid */
	id: string;
}) =>
	apiFetch<ApiResponse<null>>({
		uri: `projects/${id}`,
		method: "DELETE",
	});

/**
 * GET `/projects`
 */
export const getApiProjects = () =>
	apiFetch<ApiResponseOfIReadOnlyListOfProjectDto>({
		uri: "projects",
		method: "GET",
	});

/**
 * GET `/projects/${id}/data`
 */
export const getApiProjectsDataById = ({
	id,
}: {
	/** @format uuid */
	id: string;
}) =>
	apiFetch<ApiResponseOfProjectDataDto>({
		uri: `projects/${id}/data`,
		method: "GET",
	});

/**
 * POST `/projects`
 */
export const postApiProjects = (data: CreateProjectRequest) =>
	apiFetch<ApiResponseOfProjectDto>({
		uri: "projects",
		method: "POST",
		body: data,
	});

/**
 * PUT `/projects/${id}`
 */
export const putApiProjectsById = (
	{
		id,
	}: {
		/** @format uuid */
		id: string;
	},
	data: UpdateProjectRequest,
) =>
	apiFetch<ApiResponse<null>>({
		uri: `projects/${id}`,
		method: "PUT",
		body: data,
	});

/**
 * PUT `/projects/${id}/data`
 */
export const putApiProjectsDataById = (
	{
		id,
	}: {
		/** @format uuid */
		id: string;
	},
	data: SaveProjectDataRequest,
) =>
	apiFetch<ApiResponseOfProjectDataDto>({
		uri: `projects/${id}/data`,
		method: "PUT",
		body: data,
	});

/**
 * PUT `/projects/${id}/sharing`
 */
export const putApiProjectsSharingById = (
	{
		id,
	}: {
		/** @format uuid */
		id: string;
	},
	data: UpdateProjectSharingRequest,
) =>
	apiFetch<ApiResponse<null>>({
		uri: `projects/${id}/sharing`,
		method: "PUT",
		body: data,
	});
